// 仅用于展示，使用十进制字符串四舍五入，不改变接口值与计算精度。
export function formatDecimal(value) {
  const text = String(value ?? '').trim();
  const match = /^([+-]?)(\d+)(?:\.(\d*))?$/.exec(text);
  if (!match) return text || '—';
  const fraction = (match[3] || '').padEnd(3, '0');
  let cents = BigInt(match[2]) * 100n + BigInt(fraction.slice(0, 2));
  if (fraction[2] >= '5') cents += 1n;
  const sign = cents === 0n ? '' : match[1];
  return `${sign}${cents / 100n}.${String(cents % 100n).padStart(2, '0')}`;
}

// 全额转账只取完整的分，保留原钱包的历史余款。
export function truncateDecimal(value) {
  const match = /^([+-]?)(\d+)(?:\.(\d*))?$/.exec(String(value ?? '').trim());
  if (!match) return '0.00';
  const cents = BigInt(match[2]) * 100n + BigInt((match[3] || '').padEnd(2, '0').slice(0, 2));
  return `${match[1] === '-' && cents !== 0n ? '-' : ''}${cents / 100n}.${String(cents % 100n).padStart(2, '0')}`;
}
